<template>
  <div class="result-warp" @touchmove="hideMessage">
    <template v-if="prizeResult.type === 1">
      <div class="result">
        <img :src="require('@/assets/img/award/faiImgNew.png')" class="result-image" />
        <div class="result-text">Unfortunately, You missed the prize</div>
      </div>
      <div class="result-btn" @click="hideMessage">Play again</div>
    </template>
    <template v-if="prizeResult.type === 2">
      <div class="result">
        <img :src="require('@/assets/img/award/noAwardPic.png')" class="result-image" />
        <div class="result-text">The prizes have been distributed</div>
      </div>
      <div class="result-btn" @click="hideMessage">Play again</div>
    </template>
    <template v-if="prizeResult.type === 3">
      <div class="resule-gift-box">
        <img :src="require('@/assets/img/award/giftVer2.png')" class="result-image" />
        <img :src="require('@/assets/img/award/lightNew.png')" class="result-rotate-image" />
        <div class="result-text">
          <div class="result-name">{{ prizeResult.title }}</div>
          <p>{{ prizeResult.level }}</p>
        </div>
      </div>
      <div class="result-btn" @click="hideMessage(1)">Leave your contact info</div>
    </template>
  </div>
</template>

<script>
import { baseOssUrl } from "@/util/config";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  data() {
    return {
      baseOssUrl,
      baseSize,
    };
  },
  props: {
    content: []
  },
  computed: {
    prizeResult() {
      return this.$store.state.prizeResult;
    },
  },
  mounted() { },
  methods: {
    hideMessage(n) {
      this.$store.commit("updateValue", ["showResult", false]);
      if (n == 1) this.$store.commit("updateValue", ["showPrizeForm", true]);
    }
  }
};
</script>

<style scoped lang="scss">
.result-warp {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;
  background: rgba(0, 0, 0, 0.85);
  width: 100%;
  max-width: 640px;
  height: 100%;
  z-index: 99999;
  text-align: center;
  color: #fff;
}

.result-image {
  width: 59.2%;
  height: auto;
}

.result-text {
  margin-top: 2rem;
  font-size: 16px;
  position: relative;
  z-index: 2;
  line-height: 1.6;

  .result-name {
    font-size: 20px;
    color: #ffdb12;
  }
}

.result-btn {
  margin: 100px auto 0;
  background: rgb(229, 173, 100);
  line-height: 2.5;
  font-size: 16px;
  width: 59.2%;
  max-width: 300px;
  border-radius: 20px;
  z-index: 5;
  position: relative;
}

.resule-gift-box {
  margin-top: 60px;
  position: relative;
  z-index: 1;

  .result-image {
    position: relative;
    z-index: 2;
    width: 56%;
  }

  .result-rotate-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 76%;
    left: 12%;
    margin-top: -3.6rem;
    height: auto;
    animation: rotate 5s linear infinite;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 1600px) and (min-width: 769px) {
  .result-warp {
    .result-image {
      width: 45%;
    }

    .result-text {
      margin-top: 0;
    }

    .result-btn {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LuckDraw/Result.vue